import React from 'react'
import { Segment } from 'semantic-ui-react'
import { connect } from 'react-redux'

// @ts-ignore
import { SegmentGroup } from 'shared/StyledComponents'
import { translateBase, icon } from '../../helpers'
import Modals, { openAddNoteModal, openDeleteNoteModal } from './Modals'
import { constants as DCConstants } from '../../../DetailsContainer'

import NotesGrid from './NotesGrid'
import Tags from '../Tags'
import { modalActionTypes } from '../../constants'
import { NotesTabProps, note, NotesTabState } from '../../types'
// @ts-ignore
@connect(undefined, {
  openAddNoteModal,
  openDeleteNoteModal,
})
class NotesTags extends React.PureComponent<NotesTabProps, NotesTabState> {
  state = {
    selectedNote: null,
  }

  handleEditOpen = (note: note) => {
    this.setState({ selectedNote: note }, () => this.props.openAddNoteModal(modalActionTypes.EDIT))
  }

  handlePreviewOpen = (note: note) => {
    this.setState({ selectedNote: note }, () => this.props.openAddNoteModal(modalActionTypes.PREVIEW))
  }

  handleAddOpen = () => {
    this.setState({ selectedNote: undefined }, () => this.props.openAddNoteModal())
  }

  handleDeleteOpen = (note: note) => {
    const { ID, hash } = this.props

    this.props.openDeleteNoteModal(ID, hash, note.ID)
  }

  render() {
    const {
      data: { notes, tags, linkedfiles },
      ID,
      hash,
    } = this.props

    return (
      <SegmentGroup>
        <Segment.Group>
          <Modals
            ID={ID}
            hash={hash}
            selected={this.state.selectedNote}
            linkedfiles={linkedfiles}
            onRefresh={() => {}}
          />

          <NotesGrid
            notes={notes}
            onAddNoteModalOpen={this.handleAddOpen}
            onEditNoteModalOpen={this.handleEditOpen}
            onDeleteNoteModalOpen={this.handleDeleteOpen}
            onPreviewNoteModalOpen={this.handlePreviewOpen}
            instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Notes`}
            linkedfiles={linkedfiles}
          />

          {/* @ts-ignore */}
          <Tags data={tags} ID={ID} hash={hash} instanceName={`${DCConstants.DetailsGridPrefixes.client}-${ID}-Tags`} />
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

;(NotesTags as any).config = {
  title: () => translateBase('tb_notes'),
  name: 'notes',
  component: NotesTags,
  api: ['notes', 'tags', 'linkedfiles'],
  icon: icon('tb_notes'),
}

export default NotesTags
